// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activeMenu[data-v-73bc0f15]{opacity:.5}.fade-enter-active[data-v-73bc0f15],.fade-leave-active[data-v-73bc0f15]{transition:opacity .3s}.fade-enter[data-v-73bc0f15],.fade-leave-to[data-v-73bc0f15]{opacity:0}.layout__container[data-v-73bc0f15]{min-height:100vh}.layout__container .layout__content[data-v-73bc0f15]{width:100%}.default-layout[data-v-73bc0f15]{padding-top:size(100px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
